import React from "react";

import Section from "../../../HOC/Section";
import Header from "../../UI/Header";
import "./index.scss";

const Contact = () => {
  return (
    <Section id="contact">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>联系 </span>我们
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto text-center">
            <p>地址 广东省深圳市龙岗区龙东鸿景春天103-39 </p>
            <p>门市电话 0755-84830378</p>
            <p>电话 13714818078</p>
          </h6>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-md-9 col-lg-7 mr-auto ml-auto">
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control rounded-0"
                    aria-describedby="emailHelp"
                    placeholder="Enter Name..."
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control rounded-0"
                    aria-describedby="emailHelp"
                    placeholder="Enter email..."
                  />
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control rounded-0"
                    rows="5"
                    placeholder="Enter Message..."
                  />
                </div>
                <div className="form-group text-center">
                  <button className="btn btn-block btn-primary rounded-0 mr-auto ml-auto">
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Contact;
